export default function ButtonsComponent(opts){
    BaseConstructor.call(this)
    let container = opts.container
    let elements = {}
    let context = this

    this.generate = () =>{
        elements.container = this.createElement('div')
        elements.create_button = this.createElement('div', '', generateCreateButton())
        $(elements.container).append(elements.create_button)

        $(container).append(elements.container)
    }

    this.update = () =>{

    }

    function generateCreateButton(){
        let el = context.createElement('button')
        el.type = 'button'
        el.innerHTML = 'Criar'

        $(el).on('click', () =>{
            context.trigger('create-new-view')
        })

        return el
    }
}

ButtonsComponent.prototype = Object.create(BaseConstructor.prototype)